export var goToSearchPage = function goToSearchPage(_ref) {
  var searchParams = _ref.searchParams;
  var url = "/search".concat(searchParams ? "?".concat(searchParams) : '');
  window.location.assign(url);
};